import { ICoords } from "../models";

const getRegionCoords = (region: string) => {
  const map: { [key: string]: ICoords } = {
    Dolnośląskie: {
      lat: 51.1078852,
      lng: 17.03853760000004,
    },
    "Kujawsko-pomorskie": {
      lat: 53.12348040000001,
      lng: 18.008437800000024,
    },
    Lubelskie: {
      lat: 51.2464536,
      lng: 22.568446300000005,
    },
    Lubuskie: {
      lat: 51.9356214,
      lng: 15.506186200000002,
    },
    Łódzkie: {
      lat: 51.7592485,
      lng: 19.45598330000007,
    },
    Małopolskie: {
      lat: 50.06465009999999,
      lng: 19.94497990000002,
    },
    Mazowieckie: {
      lat: 52.2296756,
      lng: 21.012228700000037,
    },
    Opolskie: {
      lat: 50.6751067,
      lng: 17.921297600000003,
    },
    Podkarpackie: {
      lat: 50.0411867,
      lng: 21.999119599999972,
    },
    Podlaskie: {
      lat: 53.13248859999999,
      lng: 23.168840300000056,
    },
    Pomorskie: {
      lat: 54.35202520000001,
      lng: 18.64663840000003,
    },
    Śląskie: {
      lat: 50.26489189999999,
      lng: 19.02378150000004,
    },
    Świętokrzyskie: {
      lat: 50.8660773,
      lng: 20.628567699999962,
    },
    "Warmińsko-mazurskie": {
      lat: 53.778422,
      lng: 20.48011930000007,
    },
    Wielkopolskie: {
      lat: 52.841128,
      lng: 17.380167,
    },
    "Zachodnio-pomorskie": {
      lat: 53.4285438,
      lng: 14.552811600000041,
    },
  };

  return map[region] ?? { lat: 52.805, lng: 19.11666 };
};
export default getRegionCoords;
